export const getQuery = (parameter: string) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(parameter);
};
